import axios from "axios";
import { ILoggingAPIBody, ILoggingAPIsuccessResposnse } from "../types/LoggingTypes";
import { ActionDimensions } from "../dimensions/ActionDimensions";

export const LoggingAPICall = async (
    body: ILoggingAPIBody
): Promise<ILoggingAPIsuccessResposnse> => {
    return axios.post(`${process.env.REACT_APP_NEXT_PUBLIC_LOGGING_URL_CLIENT}` , body , {
        headers: {
            'Content-Type': 'application/json',
            'X-Auth-Token': process.env.REACT_APP_NEXT_PUBLIC_LOGGING_SERVER_KEY
        }
    })
};
